import styled, { css } from 'styled-components';
import { RemoteLineStatusOnPaymentProps } from '.';

export const StatusHeader = styled.div<
  Omit<RemoteLineStatusOnPaymentProps, 'onPressBack'>
>`
  display: flex;
  padding: 3rem;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  ${({ theme, status }) => css`
    background: ${theme.colors[status]};

    border-top-right-radius: calc(${theme.border.radius.large} * 2);
    border-top-left-radius: calc(${theme.border.radius.large} * 2);

    color: ${theme.colors.white};
    h1 {
      font-size: ${theme.font.sizes.xxlarge};
      color: ${theme.colors.white};
    }

    p {
      margin-top: 1.5rem;
      font-size: ${theme.font.sizes.small};
    }
  `}
`;

export const Avatar = styled.img`
  height: 7rem;
  width: 7rem;
  border-radius: 50%;
`;

export const Header = styled.div`
  padding: 1.75rem;
  display: flex;
  align-items: center;
  justify-content: space-between;

  > div {
    width: 70%;
  }

  flex-direction: row;
  text-align: flex-start;
  ${({ theme }) => css`
    background: ${theme.colors.surface};
    border-top-right-radius: calc(${theme.border.radius.large} * 2);
    border-top-left-radius: calc(${theme.border.radius.large} * 2);

    h1 {
      font-size: ${theme.font.sizes.xlarge};
    }

    p {
      font-size: ${theme.font.sizes.xsmall};
      color: ${theme.colors.highContrast};
      margin-top: 0.5rem;
    }

    b {
      font-size: ${theme.font.sizes.xsmall};
    }
  `}
`;

export const Content = styled.div`
  padding: 3rem;
  display: flex;
  flex-direction: column;
  max-height: 65rem;
  overflow: auto;

  ${({ theme }) => css`
    a {
      margin-top: 1.5rem;
      text-align: center;

      &:hover {
        cursor: pointer;
      }
    }

    button {
      color: ${theme.colors.black};
      margin-top: 2rem;
    }

    border-bottom-right-radius: calc(${theme.border.radius.large} * 2);
    border-bottom-left-radius: calc(${theme.border.radius.large} * 2);
  `}
`;

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    margin: 1rem 0;
    width: 100%;
    align-items: center;

    > div {
      width: 100%;
    }

    small {
      svg {
        color: ${theme.colors.contrast};
        margin-right: 1rem;
      }
    }
  `}
`;
